export default __webpack_public_path__ + "static/media/doctor-w-stetho.3c0d736d.jpg";